import { priceFields } from './price.fields';

export const bundleNameAndUrlFields = ['name', 'canonicalURL'];

export const bundleCardsAndProducts = [
  'name',
  'galleryImages(FULL)',
  'saved',
  'discountedPrice',
  'price',
  'canonicalURL',
  'products(price(value), onSale, stock(stockLevelStatus))'
];

export const bundlePriceFields = [
  'discountedPrice',
  'price(FULL)',
  'products(' + priceFields + ')'
];
